import { Icon } from 'antd';
import React, {Fragment} from 'react';

const IconFontCNIcon = Icon.createFromIconfontCN({
    scriptUrl: './static/vendor/iconfont_cn/iconfont.js',
});

export const IconCube = () => {
    return  ( 
        <IconFontCNIcon
        theme="filled"
        style={{color: "#37a0f4"}}
        type="cube"
        />)
}

export const IconCubeAndBackup = () => {
    return  ( <div style={{position:'relative'}}>
        <IconFontCNIcon
        theme="filled"
        style={{color: "#37a0f4", position:'inherit', zIndex:1}}
        type="cube"
        />
        <IconFontCNIcon
            theme="filled"
            style={{color: "#bfbdbd",position:'absolute', left:-3}}
            type="cube"
        />  
</div>)
}

export const IconBackup = () => {
    return  (<Fragment>
        <IconFontCNIcon
            theme="filled"
            style={{color: "#37a0f4"}}
            type="cube"
        />
        <b style={{margin:'0px 2px'}}>&#8594;</b>
        <IconFontCNIcon
            theme="filled"
            style={{color: "#bfbdbd"}}
            type="cube"
        />
</Fragment>)
}

export const IconRestore = () => {
    return  (<Fragment>
        <IconFontCNIcon
            theme="filled"
            style={{color: "#37a0f4"}}
            type="cube"
        />
        <b style={{margin:'0px 2px'}}>&#8592;</b>
        <IconFontCNIcon
            theme="filled"
            style={{color: "#bfbdbd"}}
            type="cube"
        />
</Fragment>)
}

export const IconDeleteBackup = () => {
    return  (<Fragment>
         <IconFontCNIcon
            theme="filled"
            style={{color: "#37a0f4"}}
            type="cube"
        />
        <b style={{margin:'0px 5px'}} />
        <div style={{position:'relative'}}>
                <Icon
                type="close"
                style={{color:'red', position:'absolute', bottom:'5px'}}
            />
            <IconFontCNIcon
                theme="filled"
                style={{color: "#bfbdbd"}}
                type="cube"
            />        
        </div>  
</Fragment>)
}